import React from 'react'

const BoatingRoutes = () => {
  return (
    <div>
      Routes
    </div>
  )
}

export default BoatingRoutes
